export default "__VITE_ASSET__08YKfHE1__"